import { defineChain } from 'viem'

export const chainVerse = defineChain({
  id: 5555,
  name: 'Chain Verse',
  nativeCurrency: { name: 'Oasys', symbol: 'OAS', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.chainverse.info'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Chain verse Explorer',
      url: 'https://explorer.chainverse.info',
      apiUrl: 'https://explorer.chainverse.info/api',
    },
  },
  testnet: false,
})
